export const AlertStyles = {
  'root': {
      backgroundColor: '#FEF7E4',
      borderRadius: '16px',
      //height: '60%',
      boxShadow: '2px 3px #E0E0E0',
      marginTop:'5px', 
      marginBottom: '4px',
      marginLeft: '4px',
      marginRight: '9px',
      height: '25%',  
      width:'99%',
      
  },

  'box_fecha_web':{
    width:'100%',
    fontSize:'11px',
    marginTop:'14px', 
    marginBottom: '5px',
    marginLeft: '5px',
    marginRight: '5px',
    color:'rgba(0, 0, 0, 0.54);'
  },

  'box_fecha_movil':{
    display:'flex', 
    justifyContent:'flex-end',
    width:'95%', 
    fontSize:'11px',
    color:'rgba(0, 0, 0, 0.54);'
  }
}
